import { Component, OnInit } from '@angular/core';
import { SaleService } from 'src/app/services/partner/sale.service';
import * as moment from 'moment';


@Component({
  selector: 'app-sale-home',
  templateUrl: './sale-home.component.html',
  styleUrls: ['./sale-home.component.css']
})
export class SaleHomeComponent implements OnInit {

  public selectSkladisca = true;
  public selectUre = false;
  public selectSkupine = false;
  public saleType = 'SALE_DATE_PART_01';
  public joinedParameters;
  constructor( private saleService: SaleService) { }

  ngOnInit() {
    if(!this.saleService.currentSaleParametersValue) {
      this.joinedParameters = {dateFrom: moment().startOf('month').format("DD.MM.YYYY"),
      dateTo: moment().format("DD.MM.YYYY"), chxb_datumZaDatum: false,
      chxb_samodejniDatum: true, chxb_prikaziDrzave: true,
      chxb_prikaziPoslovalnice: true, chxb_prikaziProcent: true,
      chxb_prikaziProcentNaPlan: true,
      chxb_DDV: true, chxb_EUR: true, chxb_razprto: false, reportsList: 50,
      fetch: 20};
      this.saleService.changeSaleParameters(this.joinedParameters);
    }
  }

  onSkladisceClick() {
   if(this.selectSkladisca) {
      this.selectSkladisca = true;
    } else {
      this.selectSkladisca = true;
      this.selectSkupine = false;
      this.selectUre = false;
    }

    this.saleType = 'SALE_DATE_PART_01';
  }

  onUreClick() {
    if(this.selectUre) {
      this.selectUre = true;
    } else {
      this.selectUre = true;
      this.selectSkupine = false;
      this.selectSkladisca = false;
    }
    this.saleType = 'SALE_HOUR_01';
  }

  onSkupineClick() {
    if(this.selectSkupine) {
      this.selectSkupine = true;
    } else {
      this.selectSkupine = true;
      this.selectUre = false;
      this.selectSkladisca = false;
    }
    this.saleType = 'SALE_DATE_IGRO_01';
  }
}
